import { useEffect, useState } from 'react';
import useFetch from 'use-http';
import jwt_decode from 'jwt-decode';

import { logOut } from '@marketplace/common';

import { AUTHORIZATION_URL, MARKETPLACE_DEV_CONTEXT, MARKETPLACE_DEV_DEACTIVATED } from '@marketplace/common';
import { useAPIFetchDeveloperContext, TAPIFetchDeveloperContext } from '@marketplace/api';

import { TAuthHookParams, TParsedToken, USER_AD_GROUPS } from './auth.types';
import { OAuth2Verification, getOAuthToken, getDeveloperContext, redirectTo } from './helpers';

export const useAPIAuth = (params: TAuthHookParams) => {
  const [state, setState] = useState<{
    hasDeveloperContext: boolean | undefined;
  }>({ hasDeveloperContext: undefined });
  const [userIsDeactivate, setUserIsDeactivate] = useState<boolean>(false);
  const [loading, setIsLoading] = useState(false);
  const developerContextAPI: TAPIFetchDeveloperContext = useAPIFetchDeveloperContext();
  const fetchToken = useFetch(AUTHORIZATION_URL, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });

  const authorization = async () => {
    const isAuthorized = localStorage.getItem(MARKETPLACE_DEV_CONTEXT);
    const isOAuth2Verified = !isAuthorized && OAuth2Verification(params);

    if (isOAuth2Verified) {
      setIsLoading(true);

      const token = await getOAuthToken(params, fetchToken);
      const parsedToken: TParsedToken = jwt_decode(token || '');
      const hasDeveloperContext: boolean =
        parsedToken.role === 'ADMIN' || 
        (parsedToken?.groups?.includes(USER_AD_GROUPS.AD_GRP_ADMIN) || parsedToken?.groups?.includes(USER_AD_GROUPS.AD_GRP_SUPPORT)) || 
        (await getDeveloperContext(developerContextAPI, token));
      setState({ hasDeveloperContext });

      if (hasDeveloperContext) {
        redirectTo(parsedToken);
      } else {
        setIsLoading(false);
      }

      setUserIsDeactivate(localStorage.getItem(MARKETPLACE_DEV_DEACTIVATED) === 'true');
    }
  };

  useEffect(() => {
    authorization();

    return () => {
      setIsLoading(false);
    };
  }, []);

  return {
    hasDeveloperContext: state.hasDeveloperContext,
    userIsDeactivate,
    loading,
  };
};
